<!--导航-->
<template>
  <div class="person-container" :style="'min-height:'+min_height+'px;'">
    <headerIndex/>
    <div class="personal-header">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#FFFFFF" @select="handleSelect2"
               active-text-color="#FE273B" router active-background-color="#FE273B">
        <el-menu-item :index="navigation.href" v-for="navigation of navigationBar">{{ navigation.name }}</el-menu-item>
      </el-menu>
    </div>
    <div class="left-header" :style="'min-height:'+min_heights+'px;'">
      <el-container>
        <el-aside width="180px" style="background: #ffffff;">
          <el-menu :default-active="activeIndex2" class="el-menu-vertical-demo" @select="handleSelect"
                   background-color="#FFFFFF" active-text-color="#FE273B">
            <el-menu-item :index="vertical.href" v-for="vertical of navigationBar2">{{ vertical.name }}</el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <editInformation v-if="activeIndex2=='/personal/editInformation'"/>
          <Follow v-if="activeIndex2=='/personal/follow'"/>
          <coupon v-if="activeIndex2=='/personal/coupon'"/>
          <mine-collection v-if="activeIndex2=='/personal/mineCollection'"/>
          <ship-address v-if="activeIndex2=='/personal/shipAddress'"/>
          <feedback v-if="activeIndex2=='/personal/feedback'"/>
          <about-us v-if="activeIndex2=='/personal/aboutUs'"/>
        </el-main>
      </el-container>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import editInformation from "@/views/personal/editInformation";
import Follow from "@/views/personal/follow";
import Coupon from "@/views/personal/coupon";
import MineCollection from "@/views/personal/mineCollection";
import ShipAddress from "@/views/personal/shipAddress";
import Feedback from "@/views/personal/feedback";
import AboutUs from "@/views/personal/aboutUs";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";

export default {
  name: "index",
  components: {Hang, Home_footer, AboutUs, Feedback, ShipAddress, MineCollection, Coupon, Follow, headerIndex, editInformation},
  data() {
    return {
      activeIndex: '/personal/index',
      min_height: document.documentElement.clientHeight,
      min_heights: document.documentElement.clientHeight-346,
      navigationBar: [
        {name: '订单管理', index: 1, href: '/orderManagement/index'},
        {name: '个人中心', index: 2, href: '/personal/index'},
        {name: '账号管理', index: 3, href: '/accountManagement/index'},
      ],
      activeIndex2: '/personal/editInformation',
      navigationBar2: [
        {name: '编辑资料', index: 1, href: '/personal/editInformation'},
        {name: '关注店铺', index: 2, href: '/personal/follow'},
        {name: '优惠券', index: 3, href: '/personal/coupon'},
        {name: '我的收藏', index: 4, href: '/personal/mineCollection'},
        {name: '收货地址', index: 5, href: '/personal/shipAddress'},
        {name: '意见反馈', index: 6, href: '/personal/feedback'},
        {name: '关于我们', index: 7, href: '/personal/aboutUs'}
      ],
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex2 = key;
      localStorage.setItem('personIndex',key);
    },
    handleSelect2(key){
      if (key!=''){}else{
        let routeData = this.$router.resolve({
          name: "onlineService",
          path: '/onlineService/index'
        });
        window.open(routeData.href, '_blank')
      }
    }
  },
  mounted() {
    this.activeIndex2=localStorage.getItem('personIndex') ? localStorage.getItem('personIndex'): '/personal/editInformation';
  }
}
</script>
<style scoped>
.person-container >>> .personal-header .el-menu--horizontal > .el-menu-item {
  float: left;
  height: 50px;
  line-height: 50px;
  margin: 0px 50px 0px 0px;
  padding: 0 0px;
  border-bottom: 2px solid transparent;
  color: #333333;
  font-size: 16px;
}

.person-container >>> .left-header .el-menu-item {
  height: auto;
  line-height: normal;
  font-size: 14px;
  color: #333333;
  padding: 20px 20px;
  border-bottom: 1px solid #F1F1F1;
}
.person-container >>> .left-header .el-card__body, .el-main {
  padding: 0px 0px 0px 10px;
}
</style>
<style scoped lang="scss">
.person-container {
  background: #F1F1F1;

  .personal-header {
    padding: 0px 18%;
    min-width: 76rem;
    background: #ffffff;
  }

  .left-header {
    padding: 10px 18%;
    min-width: 76rem;
    background: #F1F1F1;
  }
}
</style>